import { defineMessages } from "react-intl";

export default defineMessages({
  offerProgamTerms: {
    id: "relationships.OfferProgramTerms",
    defaultMessage: "Offer Program Terms",
  },
  pageNotFound: {
    id: "relationships.pageNotFound",
    defaultMessage: "Page Not Found",
  },
});
